import React from "react";

//Components
import FormCard from "./Childs/FormCard";
import Description from "./Childs/Description";

export default function SelectionUserType() {
  return (
    <>
      <div className="welcome-wrapper">
        <Description />
        <FormCard />
      </div>
    </>
  );
}
